import DangerCircleIcon from "assets/icons/DangerCircleIcon";
import styles from "./style.module.scss";
import XIcon from "assets/icons/XIcon";
import { useRef } from "react";
import classNames from "classnames";

export interface ErrorModalProps {
  showModal: boolean;
  hideIcon?: boolean;
  title: JSX.Element | string;
  message: JSX.Element | string;
  actionButton1?: JSX.Element;
  actionButton2?: JSX.Element;
  onClose: () => void;
}

const ErrorModal = ({
  title,
  message,
  showModal,
  hideIcon = false,
  actionButton1,
  actionButton2,
  onClose,
}: ErrorModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const containerClassnames = classNames(styles.buttonContainer, {
    [styles.singleButton]: actionButton1 && !actionButton2,
  });

  return showModal ? (
    <div className={styles.overlay} onClick={(e) => e.stopPropagation()}>
      <div className={styles.container} ref={modalRef}>
        <div className={styles.containrHeader}>
          {!hideIcon && (
            <div className={styles.titleIcon}>
              <DangerCircleIcon variant="filled" />
            </div>
          )}
          <span className={styles.containrHeaderTitle}>{title}</span>
          <div className={styles.crossIcon} onClick={onClose}>
            <XIcon />
          </div>
        </div>

        <div className={styles.divider} />

        <div className={styles.containrBody}>{message}</div>

        {(actionButton1 || actionButton2) && <div className={styles.divider} />}
        <div className={containerClassnames}>
          {actionButton1 && actionButton1}
          {actionButton2 && actionButton2}
        </div>
      </div>
    </div>
  ) : (
    <noscript />
  );
};

export default ErrorModal;
